import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PublicOfferPage: React.FC = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse' as const,
    fontSize: isMobile ? '12px' : '14px',
    marginBottom: '24px',
  };

  const thStyle = {
    padding: isMobile ? '8px' : '12px',
    textAlign: 'left' as const,
    color: '#d4af37',
    borderBottom: '2px solid rgba(212, 175, 55, 0.3)',
  };

  const tdStyle = {
    padding: isMobile ? '8px' : '12px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a2e 100%)',
      color: '#f0f0f0',
      padding: isMobile ? '16px 12px' : '20px 20px',
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        background: 'rgba(13, 20, 40, 0.85)',
        backdropFilter: 'blur(20px)',
        borderRadius: '24px',
        padding: isMobile ? '20px 16px' : '40px',
        border: '1px solid rgba(212, 175, 55, 0.12)',
        boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
        position: 'relative',
      }}>
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />

        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            color: '#d4af37',
            padding: isMobile ? '6px 12px' : '8px 16px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: isMobile ? '12px' : '14px',
            marginBottom: isMobile ? '16px' : '24px',
            transition: 'all 0.3s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'none';
          }}
        >
          ← Назад
        </button>

        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontStyle: 'italic',
          fontSize: isMobile ? '22px' : '32px',
          background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
          backgroundSize: '200% auto',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: '8px',
          textAlign: 'center',
        }}>
          Публичная оферта Astranum
        </h1>

        <div style={{
          textAlign: 'center',
          color: '#b0b0b0',
          fontSize: isMobile ? '12px' : '14px',
          marginBottom: isMobile ? '20px' : '32px',
          paddingBottom: isMobile ? '16px' : '24px',
          borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
        }}>
          Дата вступления в силу: 2026-06-26 · Версия: 1.0
        </div>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            1. Общие положения
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '12px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            1.1. Настоящий документ является публичной офертой (далее — «Оферта») в соответствии с п. 2 ст. 437 Гражданского кодекса РФ.
          </p>
          <div style={{
            background: 'rgba(212, 175, 55, 0.05)',
            border: '1px solid rgba(212, 175, 55, 0.2)',
            borderRadius: '8px',
            padding: isMobile ? '12px' : '16px',
            marginTop: '16px',
          }}>
            <p style={{ margin: '0 0 8px 0', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
              <strong style={{ color: '#d4af37' }}>Исполнитель:</strong><br />
              [Юридическое название/ИП]<br />
              Адрес: [Юридический адрес]<br />
              Email: info@astranum.pro
            </p>
            <p style={{ margin: '8px 0 0 0', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
              <strong style={{ color: '#d4af37' }}>Заказчик:</strong> Любое физическое лицо, зарегистрировавшееся на платформе Astranum.
            </p>
            <p style={{ margin: '8px 0 0 0', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
              <strong style={{ color: '#d4af37' }}>Платформа:</strong> Веб-сайт Astranum, расположенный по адресу <a href="https://astranum.ru" style={{ color: '#4fd1c5' }}>https://astranum.ru</a>
            </p>
          </div>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            2. Предмет оферты
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '12px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            2.1. Исполнитель обязуется предоставить Заказчику доступ к платформе Astranum для получения:
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '12px' : '20px', marginTop: '16px' }}>
            <div style={{
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              borderRadius: '8px',
              padding: isMobile ? '12px' : '16px',
            }}>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '14px' : '16px', marginBottom: '12px' }}>
                🔮 Астрологические расчёты
              </h3>
              <ul style={{ lineHeight: '1.8', paddingLeft: '20px', margin: 0, color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
                <li>Натальная карта</li>
                <li>Прогнозы (день, неделя, месяц)</li>
                <li>Транзиты планет</li>
              </ul>
            </div>

            <div style={{
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              borderRadius: '8px',
              padding: isMobile ? '12px' : '16px',
            }}>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '14px' : '16px', marginBottom: '12px' }}>
                🔢 Нумерологические расчёты
              </h3>
              <ul style={{ lineHeight: '1.8', paddingLeft: '20px', margin: 0, color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
                <li>Число Жизненного Пути</li>
                <li>Число Судьбы, Души, Личности</li>
                <li>Персональные циклы</li>
                <li>Совместимость партнёров</li>
                <li>Благоприятные даты</li>
              </ul>
            </div>
          </div>

          <p style={{ lineHeight: '1.8', marginTop: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <strong style={{ color: '#d4af37' }}>Консультации экспертов</strong> (при заказе)
          </p>
          <p style={{ lineHeight: '1.8', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            2.2. Заказчик обязуется оплатить услуги в соответствии с выбранным тарифом.
          </p>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            3. Тарифы и цены
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: isMobile ? '12px' : '16px', marginTop: '16px' }}>
            <div style={{
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              borderRadius: '12px',
              padding: isMobile ? '16px' : '20px',
              textAlign: 'center',
            }}>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '16px' : '18px', marginBottom: '8px' }}>Free</h3>
              <div style={{ fontSize: isMobile ? '22px' : '28px', fontWeight: 'bold', color: '#fff', marginBottom: '12px' }}>
                0 ₽
              </div>
              <ul style={{ lineHeight: '1.6', paddingLeft: '16px', margin: 0, fontSize: isMobile ? '12px' : '13px', textAlign: 'left', color: '#b0b0b0' }}>
                <li>Базовый гороскоп на день</li>
                <li>Число Жизненного Пути</li>
                <li>Ограниченный профиль</li>
              </ul>
            </div>

            <div style={{
              background: 'rgba(212, 175, 55, 0.1)',
              border: '2px solid #d4af37',
              borderRadius: '12px',
              padding: isMobile ? '16px' : '20px',
              textAlign: 'center',
              position: 'relative',
            }}>
              <div style={{
                position: 'absolute',
                top: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#d4af37',
                color: '#0a0a1a',
                padding: '2px 12px',
                borderRadius: '10px',
                fontSize: '11px',
                fontWeight: 'bold',
              }}>
                ПОПУЛЯРНЫЙ
              </div>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '16px' : '18px', marginBottom: '8px' }}>Premium</h3>
              <div style={{ fontSize: isMobile ? '22px' : '28px', fontWeight: 'bold', color: '#fff', marginBottom: '4px' }}>
                690 ₽/мес
              </div>
              <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#b0b0b0', marginBottom: '12px' }}>
                или 4 900 ₽/год
              </div>
              <ul style={{ lineHeight: '1.6', paddingLeft: '16px', margin: 0, fontSize: isMobile ? '12px' : '13px', textAlign: 'left', color: '#b0b0b0' }}>
                <li>Полная астрология</li>
                <li>Полная нумерология</li>
                <li>Экспорт в PDF</li>
                <li>Приоритетная поддержка</li>
              </ul>
            </div>

            <div style={{
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              borderRadius: '12px',
              padding: isMobile ? '16px' : '20px',
              textAlign: 'center',
            }}>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '16px' : '18px', marginBottom: '8px' }}>Консультация</h3>
              <div style={{ fontSize: isMobile ? '22px' : '28px', fontWeight: 'bold', color: '#fff', marginBottom: '12px' }}>
                от 5 000 ₽
              </div>
              <ul style={{ lineHeight: '1.6', paddingLeft: '16px', margin: 0, fontSize: isMobile ? '12px' : '13px', textAlign: 'left', color: '#b0b0b0' }}>
                <li>60 минут онлайн</li>
                <li>Персональный разбор</li>
                <li>Запись сессии</li>
                <li>Рекомендации эксперта</li>
              </ul>
            </div>
          </div>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            4. Порядок расчётов
          </h2>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            4.1. Оплата подписки
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Предоплата 100%</li>
            <li>Автоматическое продление (можно отключить)</li>
            <li>Платёж через ЮKassa</li>
          </ul>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            4.2. Оплата консультации
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Предоплата 100%</li>
            <li>Бронирование времени</li>
            <li>Отмена не позднее 24 часов</li>
          </ul>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            4.3. Возврат средств
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li><strong>Подписка:</strong> пропорционально неиспользованному периоду</li>
            <li><strong>Консультация:</strong> полный возврат при отмене за 24 часа</li>
          </ul>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            5. Права и обязанности сторон
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '16px' : '20px' }}>
            <div>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '14px' : '16px', marginBottom: '12px' }}>
                Исполнитель обязуется:
              </h3>
              <ul style={{ lineHeight: '1.8', paddingLeft: '20px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
                <li>Предоставить доступ в течение 1 часа после оплаты</li>
                <li>Обеспечить точность расчётов</li>
                <li>Гарантировать конфиденциальность данных</li>
                <li>Предоставлять техническую поддержку</li>
              </ul>
            </div>

            <div>
              <h3 style={{ color: '#d4af37', fontSize: isMobile ? '14px' : '16px', marginBottom: '12px' }}>
                Заказчик обязуется:
              </h3>
              <ul style={{ lineHeight: '1.8', paddingLeft: '20px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
                <li>Предоставить достоверные данные</li>
                <li>Оплатить услуги согласно тарифу</li>
                <li>Не передавать доступ третьим лицам</li>
                <li>Не использовать сервис в коммерческих целях</li>
              </ul>
            </div>
          </div>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            6. Активация оферты
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '12px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <strong style={{ color: '#d4af37' }}>Акцепт оферты</strong> осуществляется путём:
          </p>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Регистрации на платформе</li>
            <li>Проставления галочки «Я согласен с условиями оферты»</li>
            <li>Оплаты услуг</li>
          </ul>
          <p style={{ lineHeight: '1.8', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <strong>Дата акцепта:</strong> Дата регистрации или оплаты (что раньше).<br />
            <strong>Срок действия:</strong> Бессрочно до расторжения.
          </p>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            7. Расторжение оферты
          </h2>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            7.1. По инициативе Заказчика
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Через личный кабинет (отмена подписки)</li>
            <li>Email на <strong style={{ color: '#d4af37' }}>info@astranum.pro</strong></li>
          </ul>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            7.2. По инициативе Исполнителя
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>При нарушении условий оферты</li>
            <li>С уведомлением за 7 дней</li>
          </ul>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            7.3. Последствия расторжения
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Доступ закрывается</li>
            <li>Данные удаляются (по запросу)</li>
            <li>Возврат средств (пропорционально)</li>
          </ul>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            8. Ответственность сторон
          </h2>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            Исполнитель не несёт ответственности за:
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Косвенные убытки</li>
            <li>Упущенную выгоду</li>
            <li>Результаты использования расчётов</li>
          </ul>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            Исполнитель несёт ответственность за:
          </h3>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Непредоставление услуг</li>
            <li>Неточность расчётов (возврат средств)</li>
            <li>Утечку данных (в соответствии с законом)</li>
          </ul>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            9. Форс-мажар
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '12px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            Стороны освобождаются от ответственности при обстоятельствах непреодолимой силы:
          </p>
          <ul style={{ lineHeight: '2', paddingLeft: '20px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            <li>Стихийные бедствия</li>
            <li>Военные действия</li>
            <li>Решения государственных органов</li>
            <li>Технические сбои вне контроля Исполнителя</li>
          </ul>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            10. Разрешение споров
          </h2>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            10.1. Претензионный порядок
          </h3>
          <p style={{ lineHeight: '1.8', marginBottom: '16px', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            Письменная претензия на <strong style={{ color: '#d4af37' }}>info@astranum.pro</strong>. Срок ответа: 14 дней.
          </p>

          <h3 style={{ color: '#f0f0f0', fontSize: isMobile ? '15px' : '18px', marginBottom: '12px' }}>
            10.2. Судебный порядок
          </h3>
          <p style={{ lineHeight: '1.8', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            По месту нахождения Исполнителя, в соответствии с законодательством РФ.
          </p>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            11. Изменения оферты
          </h2>
          <p style={{ lineHeight: '1.8', color: '#b0b0b0', fontSize: isMobile ? '13px' : '14px' }}>
            Исполнитель вправе изменять оферту с уведомлением за 7 дней. Публикация на сайте,
            email-уведомление (для существенных изменений). Продолжение использования сервиса = согласие с изменениями.
          </p>
        </section>

        <section style={{ marginBottom: isMobile ? '20px' : '32px' }}>
          <h2 style={{ color: '#d4af37', fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '16px' }}>
            12. Реквизиты Исполнителя
          </h2>

          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={{ ...tdStyle, color: '#d4af37', width: '200px' }}>Юридическое лицо</td>
                <td style={tdStyle}>[Юридическое название/ИП]</td>
              </tr>
              <tr>
                <td style={{ ...tdStyle, color: '#d4af37' }}>ИНН</td>
                <td style={tdStyle}>[ИНН]</td>
              </tr>
              <tr>
                <td style={{ ...tdStyle, color: '#d4af37' }}>ОГРН</td>
                <td style={tdStyle}>[ОГРН]</td>
              </tr>
              <tr>
                <td style={{ ...tdStyle, color: '#d4af37' }}>Адрес</td>
                <td style={tdStyle}>[Юридический адрес]</td>
              </tr>
              <tr>
                <td style={{ ...tdStyle, color: '#d4af37' }}>Email</td>
                <td style={tdStyle}>info@astranum.pro</td>
              </tr>
            </tbody>
          </table>
        </section>

        <div style={{
          marginTop: isMobile ? '24px' : '40px',
          paddingTop: isMobile ? '16px' : '24px',
          borderTop: '1px solid rgba(212, 175, 55, 0.2)',
          textAlign: 'center',
          color: '#b0b0b0',
          fontSize: isMobile ? '11px' : '13px',
        }}>
          <p>Оферта утверждена: 2026-06-26 · Версия: 1.0</p>
          <p style={{ color: '#d4af37', marginTop: '8px' }}>
            ✦ Astranum — платформа астрологии и нумерологии ✦
          </p>
        </div>
      </div>
    </div>
  );
};

export default PublicOfferPage;
